// TODO: Could get these from global settings
const DAYS_TO_ADD = 3;
const DAY_IF_TOO_LATE = 25;

/**
 * Get the new recurring payment day.
 * @param today The day of the month you want to add/calculate the recurring day - usually this should be today except for testing.
 */
export const getRecurringPaymentDay = (today: number) => {
  const desiredDay = today + DAYS_TO_ADD;

  if (desiredDay <= 28) {
    return desiredDay;
  }

  // If calculated payment day is after the 28th, choose the 25th;
  return DAY_IF_TOO_LATE;
};
